const PropTypes = require('prop-types');
const React = require('react');
const PaymentMethodSelection = require('../payment_method_selection');
const {
  actions: PaymentMethodSelectionActions,
  store: PaymentMethodSelectionStore,
} = require('../payment_method_selection_module');
const { mapStateToProps } = require('@reverbdotcom/discovery-ui');

function mapper() {
  const { shopCurrency, originalShopCurrency } = PaymentMethodSelectionStore.getState();

  return {
    shopCurrency,
    onCurrencyChange: PaymentMethodSelectionActions.updateShopCurrency,
    originalCurrencyCode: originalShopCurrency,
  };
}

const WrappedPaymentMethodSelection = mapStateToProps({
  mapper, stores: [PaymentMethodSelectionStore],
})(PaymentMethodSelection, 'PaymentMethodSelection');

class PaymentMethodSelectionContainer extends React.Component {
  componentDidMount() {
    this.assignInitialState();
  }

  assignInitialState() {
    PaymentMethodSelectionActions.initializeShopCurrency(this.props.shopCurrency);
  }

  render() {
    return (
      <WrappedPaymentMethodSelection {...this.props} />
    );
  }
}

PaymentMethodSelectionContainer.propTypes = {
  allowDirectCheckout: PropTypes.bool.isRequired,
  allowDirectCheckoutAndPaypal: PropTypes.bool.isRequired,
  directCheckoutFeePercent: PropTypes.number.isRequired,
  directCheckoutIntlFeePercent: PropTypes.number.isRequired,
  directCheckoutProfileProps: PropTypes.shape({
    profileAttributes: PropTypes.shape({
      nameOnAccount: PropTypes.string,
      maskedNameSummary: PropTypes.string,
      bankName: PropTypes.string,
      countryCode: PropTypes.string,
      payoutMethod: PropTypes.string,
      hasAcceptedReverbBankTerms: PropTypes.bool.isRequired,
      profileErrors: PropTypes.string,
    }).isRequired,
    payoutCurrencies: PropTypes.object.isRequired,
    initiallyReadOnly: PropTypes.bool,
    shopLocatedInUs: PropTypes.bool.isRequired,
    dcProfileComplete: PropTypes.bool.isRequired,
    bankLookupUrl: PropTypes.string.isRequired,
    preferredSeller: PropTypes.bool,
    hasCompletedPayouts: PropTypes.bool,
    hasLayawayEnabled: PropTypes.bool,
    countryCodeOptions: PropTypes.array.isRequired,
    formPrefix: PropTypes.string.isRequired,
    reverbBankCurrencies: PropTypes.array.isRequired,
    selected: PropTypes.bool,
    shopCurrency: PropTypes.string,
  }).isRequired,
  paypalProfileProps: PropTypes.shape({
    initiallyReadOnly: PropTypes.bool.isRequired,
  }).isRequired,
  shopCurrency: PropTypes.string.isRequired,
  paypalCurrencies: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    code: PropTypes.string,
  })).isRequired,
  directCheckoutCurrencies: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    code: PropTypes.string,
  })).isRequired,
  currencyErrors: PropTypes.arrayOf(PropTypes.string),
  initiallySelectedPaymentMethod: PropTypes.string.isRequired,
  formPrefix: PropTypes.string.isRequired,
  paymentSelection: PropTypes.string.isRequired,
};

PaymentMethodSelectionContainer.defaultProps = {
  currencyErrors: [],
};

module.exports = PaymentMethodSelectionContainer;



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/selling/shop_policies/containers/payment_method_selection_container.jsx